import { useState } from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import StepContent from "@mui/material/StepContent";
import { ReactComponent as PasoIncompletoIcon } from "../../assets/img/svg/providers/StepperPasoIncompleto.svg";
import { ReactComponent as PasoCompletoIcon } from "../../assets/img/svg/providers/TrackerPasoCompleto.svg";
import { proveedorSteps } from "../../utils/notificationsHelpers";
import { parseDate } from "../../utils/notificationsHelpers";
import {
  updateTrackerProviderEvents,
  getTrackerProveedoresEvents,
} from "../../components/functions/Notifications";
import CustomButton from "../../ui/button/Button";
import StepperModal from "../../features/stepperModal/StepperModal";

export default function TrackerProvidersStepper({
  API_URL,
  events,
  user,
  id_empresa,
  setEvents,
  nombre,
  empresa_email,
}) {
  const [openModal, setOpenModal] = useState(false);
  const [selectedStep, setSelectedStep] = useState(null);

  const handleOpenModal = (step) => {
    setSelectedStep(step);
    setOpenModal(true);
  };

  const handleUpdateEvent = async (estatus, reason, details) => {
    await updateTrackerProviderEvents(
      API_URL,
      id_empresa,
      selectedStep.etapa,
      estatus,
      estatus === "error" ? reason : details,
      user.id,
      nombre,
      user.correo,
      user.nombre,
      empresa_email
    );

    const newEvents = await getTrackerProveedoresEvents(API_URL, id_empresa);
    setEvents(newEvents);
  };

  return (
    <>
      <StepperModal
        onClose={() => setOpenModal(false)}
        open={openModal}
        title={selectedStep ? selectedStep.description : ""}
        onConfirm={handleUpdateEvent}
      />
      <Box sx={{ maxWidth: 600, width: "100%" }}>
        <Stepper nonLinear orientation="vertical">
          {proveedorSteps.map((step, index) => {
            const etapa = events.find((e) => e.etapa === step.etapa);
            const lastEtapa = Math.max(...events.map((e) => e.etapa));

            if (etapa) {
              const { date, time } = parseDate(etapa.updated_at);
              etapa.date = date;
              etapa.time = time;
            }
            return (
              <Step expanded key={step.etapa}>
                <StepLabel
                  icon={
                    etapa && etapa.estatus === "completado" ? (
                      <PasoCompletoIcon />
                    ) : (
                      <PasoIncompletoIcon />
                    )
                  }
                >
                  <h2 style={{ margin: 0 }}>{step.description}</h2>
                </StepLabel>
                {!etapa ? (
                  <StepContent>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        width: "600px",
                      }}
                    >
                      <div style={{ display: "flex", flexDirection: "column" }}>
                        <p style={{ margin: 0 }}>-------</p>
                        <p style={{ margin: 0 }}>-------</p>
                        <p style={{ margin: 0, color: "gray" }}>Pendiente</p>
                      </div>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <p style={{ margin: 0, color: "gray" }}>Pendiente</p>
                      </div>
                      <CustomButton
                        className="notifications-button"
                        text={"Acciones"}
                        color={"#FFFFFF"}
                        border={"none"}
                        background={"#223D51"}
                        fontStyle={"normal"}
                        fontWeight={500}
                        fontSize={"14px"}
                        height={"28px"}
                        type={"button"}
                        visibility={
                          lastEtapa === step.etapa ? "visible" : "hidden"
                        }
                        onClick={() => handleOpenModal(step)}
                      />
                    </div>
                  </StepContent>
                ) : (
                  <StepContent>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div style={{ display: "flex", flexDirection: "column" }}>
                        <p style={{ margin: 0 }}>{etapa.date}</p>
                        <p style={{ margin: 0 }}>{etapa.time}</p>
                        <p
                          style={{
                            margin: 0,
                            color:
                              etapa.estatus === "completado"
                                ? "#40A855"
                                : etapa.estatus === "error"
                                ? "red"
                                : "orange",
                          }}
                        >
                          {`${
                            etapa.estatus.charAt(0).toUpperCase() +
                            etapa.estatus.slice(1)
                          }`}
                        </p>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          textAlign: "right",
                        }}
                      >
                        <p
                          style={{
                            margin: 0,
                            wordBreak: "break-word",
                            maxWidth: "160px",
                          }}
                        >
                          {etapa.detalles || "Sin detalles adicionales"}
                        </p>
                      </div>
                      <CustomButton
                        className="notifications-button"
                        text={"Acciones"}
                        color={"#FFFFFF"}
                        border={"none"}
                        background={"#223D51"}
                        fontStyle={"normal"}
                        fontWeight={500}
                        fontSize={"14px"}
                        height={"28px"}
                        type={"button"}
                        visibility={
                          lastEtapa === step.etapa ? "visible" : "hidden"
                        }
                        onClick={() => handleOpenModal(step)}
                      />
                    </div>
                  </StepContent>
                )}
              </Step>
            );
          })}
        </Stepper>
      </Box>
    </>
  );
}
